module.exports = __webpack_public_path__ + "img/Foodie-Photos-Icon.e1cd863e.svg";